import React, { useRef, useState, useCallback } from "react";
import { useAIChat } from "./AIChatContext";

const AIChatButton = () => {
  const { toggle, isOpen, streaming } = useAIChat();
  const [pos, setPos] = useState({ top: 48, right: 20 });
  const dragRef = useRef({ startX: 0, startY: 0, startTop: 48, startRight: 20, dragging: false });
  const [dragging, setDragging] = useState(false);

  const onMouseDown = useCallback((e) => {
    dragRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      startTop: pos.top,
      startRight: pos.right,
      dragging: false,
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }, [pos]);

  const onMouseMove = useCallback((e) => {
    const dx = e.clientX - dragRef.current.startX;
    const dy = e.clientY - dragRef.current.startY;
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
      dragRef.current.dragging = true;
      setDragging(true);
    }
    if (dragRef.current.dragging) {
      setPos({
        top: Math.max(10, dragRef.current.startTop + dy),
        right: Math.max(10, dragRef.current.startRight - dx),
      });
    }
  }, []);

  const onMouseUp = useCallback(() => {
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
    if (!dragRef.current.dragging) {
      toggle();
    }
    setDragging(false);
  }, [toggle, onMouseMove]);

  if (isOpen) return null;

  return (
    <div
      onMouseDown={onMouseDown}
      title="AI Chat"
      style={{
        position: "fixed",
        top: pos.top,
        right: pos.right,
        zIndex: 1000,
        background: streaming ? "#f59e0b" : "linear-gradient(135deg, #6366f1, #4f46e5)",
        border: "none",
        borderRadius: "50%",
        width: 48,
        height: 48,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: dragging ? "grabbing" : "grab",
        fontSize: "1.3rem",
        boxShadow: "0 4px 12px rgba(99,102,241,0.4)",
        transition: dragging ? "none" : "box-shadow 0.2s",
        color: "#fff",
        userSelect: "none",
      }}
    >
      {streaming ? "⏳" : "🤖"}
    </div>
  );
};

export default AIChatButton;
